<template>
<div>
  <!-- 参展店铺 -->
  <el-col class="order_content">
    <div class="">
      <p class="stepTitle" style="margin-left: 20px">参展店铺</p>
    </div>
    <!-- table 列表 -->
    <div class="table_container">
      <div class="table_inner_container" style="height: auto">
        <el-table :data="dataList" class="invoice_tab" stripe border style="height: auto;">
          <el-table-column label="序号" align="center" width="60">
            <template scope="scope"> <span>{{scope.$index + 1}}</span> </template>
          </el-table-column>
          <!-- <el-table-column label="参展品牌" align="center">
            <template scope="scope">{{ scope.row.BrandName }}</template>
          </el-table-column> -->
          <el-table-column label="参展店铺" align="center">
            <template scope="scope">{{ scope.row.name }}</template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="300" align="center" v-if="setType != 2">
            <template slot="header">
              <button class="redBackground" @click="addRelatedBrand()"> 新增 </button>
            </template>
            <template scope="scope">
              <span @click="deleteBrand(scope.row)" class="handle">
                <i class="el-icon-delete"></i> 删除
              </span>
              <!-- <span @click="spUpordown(1, scope.row)" class="handle">
                <i class="el-icon-upload2" /> 向上
              </span>
              <span @click="spUpordown(2, scope.row)" class="handle">
                <i class="el-icon-download" /> 向下
              </span> -->
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div style="padding-left: 0; margin: 22px auto; text-align: center">
        <button type="button" @click="toPrevStep"
          class="el-button el-button--default cancle normal_btn">
          上一步
        </button>
        <button type="button" @click="toNextStep"
          class="el-button el-button--default search_btn normal_btn">
          下一步
        </button>
      </div>
    </div>
  </el-col>
  <!-- 新增参展店铺-弹框 -->
  <el-dialog title="参展店铺" class="add_order_cancle" width="36%" :visible.sync="vRelatedBrands">
    <el-form>
      <el-form-item style="width: 100%; display: flex">
        <!-- <el-cascader v-model="exhibitionId" placeholder="请选择参展品牌" filterable clearable
          style="background: #fff; width: 100%" :options="optionExhibitions" @change="handleChange"/> -->
        <el-select v-model="exhibitionId" filterable placeholder="请选择店铺">
          <el-option v-for="(item, index) in exhibitingBrands" :key="index" :value="item.id" :label="item.name"/>
        </el-select>
      </el-form-item>
    </el-form>
    <!-- 弹框按钮 确定/取消 -->
    <div style="padding-left: 0; text-align: center">
      <button type="button" @click="vRelatedBrands = false"
        class="el-button el-button--default cancle normal_btn">
        取消
      </button>
      <button type="button" @click="editBrand()"
        class="el-button el-button--default search_btn normal_btn">
        保存
      </button>
    </div>
  </el-dialog>
</div>
</template>
<script>
import { getUpdateActiveExhibitionBrandOrde,getSelectUnAddedActivityBrand,
  getactivityshop, activityGetareashop, activityShopAdd, activityShopDel } from "../../api/addActiviteForm";
export default {
  name: "exhibitionBrand",
  data() {
    return {
      editActivityId: "", // 活动id
      dataList: [], // 列表
      vRelatedBrands: false, // 参展品牌弹框
      exhibitionId: "", // 参展品牌
      optionExhibitions: [], // 参展品牌数据列
      exhibitingBrands: [], // 参展店铺数据列-new

      // 参展品牌 (类别+品牌+店铺)
      categoryId: 0, // 二级品类
      brandId: 0,
      brandBusinessId: 0,
      setType: '', //0 新增 1 编辑  2 查看
      newactiveListData:''
    };
  },
  methods: {
    initComponent(val,type,activeListData) {
      this.editActivityId = val;
      this.setType = type;
      this.newactiveListData = activeListData;
      this.init();
    },
    // 上一步
    toPrevStep() {
      this.$emit("toPrevStep", 0,this.setType);
    },
    // 下一步
    toNextStep() {
      if(this.dataList == [] || this.dataList == null || this.dataList.length == 0) {
        if(this.setType != 2) {
          this.$swal({
            type: "warning",
            text: "请新增参展店铺",
          });
          return false;
        }
      }
      this.$emit("toNextStep", 2, this.editActivityId, this.newactiveListData);
    },
    // 初始化
    init() {
      let obj = {
        activityId: this.editActivityId, // 活动ID
        statusId: 0,
        shopId: localStorage.BbId?localStorage.BbId:0, // 店铺ID
      };
      getactivityshop(obj).then(data => {
        if (data) {
          if (data.resultCode == 1) {
            this.dataList = data.resultObj;
          }
        }
      })
    },
    // 新增
    addRelatedBrand() {
      this.exhibitionId = "";
      this.vRelatedBrands = true;
      // this.getprovince(); // 原三级级联
      this.groundingShop(); // 获取当前活动所属城市下的所有上架店铺
    },
    // 保存 新增的参展店铺
    editBrand() {
      if (this.exhibitionId == "") {
        this.$swal({
          type: "warning",
          text: "请选择参展店铺",
        });
      } else {
        var obj = {
          activityId: this.editActivityId, // 活动ID
          shopId: this.exhibitionId, // 店铺ID
        };
        activityShopAdd(obj).then((data) => {
          if (data.resultCode == 1) {
            this.init();
            this.vRelatedBrands = false;
          }
        });
      }
    },
    // 操作向上 & 向下
    spUpordown(val, row) {
      var obj = {
        activeId: this.editActivityId, // 活动id
        axBrandId: row.id, // 参展店铺id（参展店铺列表中的id）
        direction: val, // 类型 1：向上、2：向下
      };
      getUpdateActiveExhibitionBrandOrde(obj).then((data) => {
        if (data.ResultCode == 1) {
          this.dataList = data.ResultObj;
        }
      });
    },
    // 单条删除-列表数据
    deleteBrand(row) {
      this.$swal({
        type: "warning",
        text: "重要信息，你确定要删除吗？",
        showCancelButton: true,
        cancelButtonText: "取消",
        confirmButtonText: "确定",
      }).then((res) => {
        if (res.value) {
          var obj = {
            activityId: this.editActivityId, // 活动id
            shopId: row.id, // 活动参展店铺id（参展店铺列表中的id）
          };
          activityShopDel(obj).then((data) => {
            if (data.resultCode == 1) {
              this.$swal({
                type: "success",
                text: data.resultMsg,
              });
              this.init();
            } else {
              this.dataList = [];
            }
          });
        }
      });
    },
    // 请选择参展品牌
    handleChange(val) {
      this.categoryId = val[0];
      this.brandId = val[1];
      this.brandBusinessId = val[2];
    },
    // 获取参展品牌列表接口
    getprovince() {
      var loginParams = {
        activeId: this.editActivityId // 活动id
      };
      getSelectUnAddedActivityBrand(loginParams).then((data) => {
        let that = this;
        let exhibitionBrand = [];
        data.ResultObj.map((item) => {
          // 一级
          let provinceData = { value: item.Id, label: item.Name, children: [] };
          exhibitionBrand.push(provinceData);
          // 二级
          item.Brands.map((secondLevel) => {
            let cityData = { value: secondLevel.Id, label: secondLevel.Name, children: [] };
            provinceData.children.push(cityData);
            // 三级
            secondLevel.BrandBusinesses.map((threeLevels) => {
              cityData.children.push({ value: threeLevels.Id, label: threeLevels.Name });
            });
          });
        });
        that.optionExhibitions = exhibitionBrand;
      });
    },
    // 获取当前活动所属城市下的所有上架店铺
    groundingShop() {
      var obj = {
        activityId: this.editActivityId, // 活动id
        // shopName: '', // 店铺名称 模糊匹配
      };
      activityGetareashop(obj).then((data) => {
        if (data.resultCode == 1) {
          this.exhibitingBrands = data.resultObj;
        }
        if (data.resultCode == 4) {
          this.exhibitingBrands = [];
        }
      });
    },

  },
};
</script>
<style scoped>
.redBackground {
  width: 80px;
  height: 35px;
  line-height: 33px;
  font-size: 14px;
  background-color: #F56C6C;
  border: 1px solid #F56C6C;
  text-align: center;
  color: #fff;
  border-radius: 3px;
  cursor: pointer;
  outline: none;
}
</style>


// WEBPACK FOOTER //
// exhibitionBrandList.vue?19fe1d09